import React, { useContext } from 'react'
import { observer } from "mobx-react-lite";
import { BoxArrowUpRight, ArrowRight } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { CampaignContext } from '../../../../../../contexts/CampaignContext';

export default observer(function CampaignInfluencerSidebarHeader({ auth }) {
  const { id } = useParams()
  const navigate = useNavigate()
  const { campaignState } = useContext(CampaignContext)

  return (
    <div className='flex justify-between p-4'>
      <div className="flex items-center">
        <img src={auth.avatar} className='bg-rb-green border-1 border-grey-500 rounded-full w-8 h-8 mr-2' />
        <span className='text-xl'>{auth.username}</span>
        <button
          onClick={() => window.open(`/project_manager/authentications/${auth.authentication_id}/influencer/overview`, '_blank', 'noopener,noreferrer')}
        >
          <BoxArrowUpRight className='ml-2 text-sm text-rb-green' />
        </button>
      </div>
      <button
        className='flex gap-1 items-center hover:bg-gray-200 rounded-lg p-2'
        onClick={() => {
          campaignState.selectedInfluencerAuth = null
          navigate(`/project_manager/campaigns/${id}/influencers`)
        }}
      >
        <span>Back</span>
        <ArrowRight />
      </button>
    </div>
   );
})
